import { useState } from 'react'
import { Box } from '@mui/material'
import { BaseButtons, BaseForm, BaseTextInput, BaseGridLayout, BaseFeedbackConIcona, capitalizza } from '@lucan/base-ui'
import { useVerbale } from 'configuration/ConfigurazioneApi'
import { LINK_ACCESSO } from 'configuration/link'
import Titolo from 'components/ui/Titolo'
import Testo from 'components/ui/Testo'
import useNavigate from 'utils/useNavigate'

const CFG = LINK_ACCESSO

export default function AccessoChiaveVerbale(props) {
  const { 
    val, txt, 
    chiaveRottaDopoAccesso,
    salvaChiaveVerbale, 
    salvaVerbale, 
  } = props

  const { navigate } = useNavigate()

  const [messaggioErrore, setMessaggioErrore] = useState(null)

  const {
    ScatolaMessaggi,
    getVerbale,
    inAttesaDelServer
  } = useVerbale()

  async function confermaChiaveVerbale(valoriForm) {
    setMessaggioErrore(null)

    const { chiave } = valoriForm
    const { ok, data } = await getVerbale(chiave)

    const { esito, messaggio, verbale } = data
    if (ok && esito) {
      salvaChiaveVerbale(chiave)
      salvaVerbale(verbale)
      navigate(chiaveRottaDopoAccesso)
    }

    if (messaggio) {
      setMessaggioErrore(messaggio)
    }
  }

  return (
    <>
      <Titolo>{txt(CFG.CHIAVE_WEB_TITOLO)}</Titolo>
      <Testo>{txt(CFG.CHIAVE_WEB_DESCRIZIONE)}</Testo>
      <Box sx={{ p: 0 }}>
        <BaseForm
          onSubmit={confermaChiaveVerbale}
          inAttesa={inAttesaDelServer}
        >
          <BaseTextInput
            label={val(CFG.CHIAVE_WEB_CAMPO_CHIAVE)}
            name='chiave'
            required
            validazione={{
              pattern: {
                value: /^([A-Z0-9]){4}-([A-Z0-9]){4}-([A-Z0-9]){4}/,
                message: val(CFG.CHIAVE_WEB_FORMATO_CHIAVE_NON_CORRETTO)
              }
            }}
            larghezza={16}
          />
          <br />
          <BaseButtons.Custom
            testo={val(CFG.CHIAVE_WEB_BOTTONE_CONFERMA)}
            submit
            sx={{ mt: 2 }}
          />

          {ScatolaMessaggi}

          {messaggioErrore &&
            <BaseGridLayout justifyCenter>
              <BaseFeedbackConIcona.Errore messaggio={capitalizza(messaggioErrore)} />
            </BaseGridLayout>
          }
        </BaseForm>
      </Box>
    </>
  )
}